import { Box, Button, Typography, CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { API } from '../../../../../api';
import { modulesToContentPayload } from './mappers';
import { useProgramCreation } from '../../ProgramCreationContext';
import { ManualProgramBuilder } from '../manual/ManualProgramBuilder';
import StepNavigator from '../components/StepNavigator';
import DosenButton from '../../../../ui/Buttons/DosenButton';

export function StepAI_Review() {
  const { state, dispatch } = useProgramCreation();
  const navigate = useNavigate();
  const selectedDocIds = state.ai.selectedDocIds || [];
  const modules = state.modules || [];
  const contentReady = Boolean(state.ai.content);
  const isGeneratingContent = state.ai.contentLoading || state.ai.contentPollingActive;

  useEffect(() => {
    if (!state.groupId || !state.generationId) {
      navigate('../documents', { replace: true });
    }
  }, [state.groupId, state.generationId, navigate]);

  const handleGenerateContent = async () => {
    if (!selectedDocIds.length) {
      toast.error('Select at least one document for the AI to use.');
      return;
    }

    if (!state.groupId || !state.generationId) {
      toast.error('We could not find the workspace for this program. Please restart the AI flow.');
      return;
    }

    if (!modules.length) {
      toast.error('Structure is missing. Please go back to Documents and generate the structure again.');
      return;
    }

    try {
      dispatch({ type: 'SET_AI_CONTENT_LOADING', payload: true });
      dispatch({ type: 'SET_AI_STEP', payload: 4 });

      const contentResponse = await API.generateProgramContent({
        generalPurpose: state.ai.purpose.description,
        learningObjectives: state.ai.objectives,
        modules: modulesToContentPayload(modules),
        orgDocsIds: selectedDocIds,
        programGenerationId: state.generationId
      });

      const contentPayload = contentResponse?.data ?? contentResponse;
      dispatch({ type: 'SET_AI_CONTENT', payload: contentPayload });
      dispatch({ type: 'SET_AI_CONTENT_POLLING', payload: true });
      toast.info('We are generating your program content. This may take a moment.');
    } catch (err) {
      console.error('AI content generation error', err);
      toast.error('We were unable to generate the program. Please try again.');
      dispatch({ type: 'SET_AI_CONTENT_LOADING', payload: false });
      dispatch({ type: 'SET_AI_CONTENT_POLLING', payload: false });
    }
  };

  const handleNext = async () => {
    if (contentReady) {
      navigate('../members');
      return;
    }
    await handleGenerateContent();
  };

  const nextLabel = contentReady
    ? 'Create'
    : isGeneratingContent
    ? 'Generating content…'
    : 'Generate content';

  return (
    <Box display="flex" flexDirection="column" height="100%" bgcolor="#0F0F0F">
      <Box sx={{ mb: 2 }}>
        <StepNavigator currentStep="Review" />
      </Box>
      {/* <Box p={3} borderBottom="1px solid #2A2A2A">
        <Typography color="#FDFDFD" fontSize={28} fontWeight={600}>
          Review Your AI Draft
        </Typography>
        <Typography color="#B6B6B6" mt={1}>
          Adjust the generated structure before inviting members. You can return to documents if you need to tweak your references.
        </Typography>
        {!contentReady && (
          <Typography color="#B6B6B6" mt={1} fontSize={14}>
            Once you finish refining the modules and lessons, click Next to generate the lesson content so you can see each lesson’s details.
          </Typography>
        )}
        {contentReady && (
          <Typography color="#B6B6B6" mt={1} fontSize={14}>
            Lesson content is ready. You can now click on any lesson to view and fine-tune the generated details.
          </Typography>
        )}
      </Box> */}

      <Box flex={1} minHeight={0}>
        <ManualProgramBuilder showLessonEditor={contentReady} skipTopicIndustryUpdate={false}/>
      </Box>

      <Box borderTop="1px solid #2A2A2A" p={3} display="flex" justifyContent="space-between">
        <Button variant="outlined" onClick={() => navigate('../documents')} sx={{ color: '#FDFDFD', borderColor: '#FDFDFD' }}>
          Back
        </Button>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-end' }}>
          {/* {!contentReady && (
            <Typography color="#B6B6B6" fontSize={12}>
              Content must be generated before moving to Members.
            </Typography>
          )} */}
          <DosenButton
            // variant="contained"
            onClick={handleNext}
            disabled={isGeneratingContent}
            // sx={{ bgcolor: '#F79420', color: '#0F0F0F', '&:hover': { bgcolor: '#ff9f2d' } }}
          >
            {nextLabel}
          </DosenButton>
        </Box>
      </Box>
    </Box>
  );
}
